import {
  Button,
  Center, Group, Modal, PasswordInput,
  Space,
  Text,
  TextInput,
  UnstyledButton
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React, { useState } from "react";
import { Location, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import InputField from "../components/input_field";
import { FORGOT_PASSWORD } from "../services/auth";
import { showNotification } from "@mantine/notifications";

export default function Login(){
  const { login, user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 900px)');

  const [email, setEmail] = useState("");
  const [forgot, setForgot] = useState(null);
  const [password, setPassword] = useState("");

  const state = location.state as { from: Location };
  const from = state ? state.from.pathname : "/";

  const confirmForgot = e => {
    e.preventDefault();
    const email = forgot.email;
    FORGOT_PASSWORD(email)
    .then(() => {
      setForgot(null);
      showNotification({title: "Recuperação de senha", message: `Foi enviado um e-mail para ${email} com instruções para recuperar sua senha`})

    })
    .catch(err => {
      showNotification({title: "Ops", message: "Falha ao recuperar senha", color: 'red'})
    }) 
  }

  return !!user
  ? <Navigate to="/" state={{ from }} />
  : (
    <Center style={{ width: "100vw", minHeight: "100vh", background: `linear-gradient(to top right, #ff7400, #ff7400, #ff7400)` }}>
      <div
        style={{
          width: isMobile ? '90vw' : "40vw",
          display: "flex",
          flexDirection: "column",
          paddingBottom: 80,
        }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            login(email, password, () => {
              navigate(from, { replace: true });
            });
          }}
        >
          <div style={{display: 'flex', marginTop: 0, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            <img alt="Satify" src={`/logo.jpeg`} style={{height: 200, marginBottom: 0 }} />
          </div>
          <TextInput
            mt="md"
            label="E-mail"
            styles={{ label: {color: 'white'} }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            />
          <PasswordInput
            mt="md"
            styles={{ label: {color: 'white'} }}
            label="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Space h="xl" />
          <UnstyledButton onClick={() => setForgot({email: ""})}>
            <Text underline size="sm" color="white">Esqueci minha senha</Text>
          </UnstyledButton>
          <Space h="xl" />
          <div style={{textAlign: 'right'}}>
            <Button
              type="submit"
              style={{ color: '#6a6a6a' }}
              mt="xl"
              color="white"
              >
              Entrar
            </Button>
          </div>
        </form>
      </div>

      <Modal size="sm" opened={!!forgot} onClose={() => setForgot(null)}>
        <form onSubmit={confirmForgot}>
          <InputField name="email" placeholder="Digite seu e-mail" title="E-mail" value={forgot?.email} onChange={({email}) => setForgot(f => ({...f, email}))} />
          
          <Group position="right" mt="lg">
            <Button color="orange" variant="light" type="button" mr="xs" onClick={() => setForgot(null)}>Cancelar</Button>
            <Button color="orange" variant="filled" type="submit">Recuperar Senha</Button>
          </Group>
        </form>
      </Modal>
    </Center>
  );
};
